import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(['WebformElementNumber'], (item) => {
  return {
    $formkit: 'number',
    min: item.element.min || '',
    max: item.element.max || '',
    step: item.element.step || '',
  }
})
